import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router-dom";
import {
  isAdminLoggedIn,
  isLoggedIn,
  setUser,
  setUserAdmin,
} from "../../store";
import { useDispatch } from "react-redux";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

import { url } from "../../configlink";

export default function AuthLogin() {
  // const EMAIL_REGEX =
  //   /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  // const PHONE_REGEX = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  // const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
  const [data, setData] = useState({
    email: "",
    password: "",
  });

  let [showPassword, setShowPassword] = useState(false)
  
  let [inactiveMessage, setInactiveMessage] = useState(false)

  useEffect(() => {
    if(localStorage.getItem('logoutmessage')) {
        if(localStorage.getItem('logoutmessage') === '1') {
          setInactiveMessage(true)
          
          setTimeout(() => {
            localStorage.removeItem('logoutmessage')
          }, 1000)
        }
    } else {
        // console.log("NOT THERE");
        setInactiveMessage(false)
    }
  }, [])

  useEffect(() => {
    const handleEnter = (event) => {
      if (event.key === "Enter") {
        loginAdmin();
      }
    };
    document.addEventListener("keydown", handleEnter);
    return () => {
      document.removeEventListener("keydown", handleEnter);
    };
  }, [data.email, data.password]);

  useEffect(() => {
    setInvalidLogin("")
  }, [data.email, data.password])

  const [invalidLogin, setInvalidLogin] = useState("");
  let [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validate = () => {
    const newErrors = {};
    if (!data.email) {
      newErrors.email = "Please enter email address / username";
    }
    if (!data.password) newErrors.password = "Please enter password";

    return { newErrors: newErrors };
  };

  const loginAdmin = async () => {
    const validationErrors = validate();

    // alert("test");
    if (Object.keys(validationErrors.newErrors).length > 0) {
      setErrors(validationErrors.newErrors);
    } else {
      try {
        const response = await fetch(`${url}/api/auth/admin_login`, {
          method: "POST",
          credentials:'include',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })

        const data2 = await response.json()

        if(response.ok){

          dispatch(isAdminLoggedIn(true));
          dispatch(setUserAdmin(data2.adminName));
          // alert("Success")
		localStorage.setItem('token_expiry', (Date.now() + 15 * 60 * 1000).toString());
          navigate("/admin/user/orders");
        }
        else{
          setInvalidLogin(data2.message);
        }
      } catch (error) {
        // console.error(error);
        setInvalidLogin("An error occurred during login.");
      }
    }
  }

  return (
    <div className="flex flex-col items-center p-10">
      <p className="text-center text-[30px] mb-[80px] mt-[50px]">
        Admin Portal
      </p>
      <div className="border border-1 border-black w-[700px] p-10 ">
      <Container component='main' maxWidth='xs'>
        <Box
          sx={{
            marginTop: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography component='h1' variant='h5'>
            Sign in
          </Typography>
          <Box component='div' noValidate sx={{ mt: 1, position:'relative', width:'100%' }}>
            <TextField
              margin='normal'
              required
              fullWidth
              id='email'
              label='Email / Username'
              name='email'
              // autoComplete='email'
              autoFocus
              sx={{
                '& label.Mui-focused': {
                  color: 'var(--color-primary-purple)',
                },
                '& .MuiOutlinedInput-root': {
                  '&.Mui-focused fieldset': {
                    borderColor: 'var(--color-primary-purple)',
                  },
                },
              }}
              onChange={(e) => {
                setErrors({...errors, message:'', email:''})
                setData({...data, email: e.target.value})
              }}
            />
            {errors.email && (
              <span className='text-[14px] text-red-500 font-bold relative top-[-8px]'>
                {errors.email}
              </span>
            )}
            <Box component={"div"} sx={{width:'100%', position:'relative'}}>
            <TextField
                margin='normal'
                required
                fullWidth
                name='password'
                label='Password'
                type={showPassword?'text':'password'}
                id='password'
                sx={{
                  '& label.Mui-focused': {
                    color: 'var(--color-primary-purple)',
                  },
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                      borderColor: 'var(--color-primary-purple)',
                    },
                  },
                }}
                // autoComplete='current-password'
                onChange={(e) => {
                  setErrors({...errors, message:'', password:''})
                  setData({...data, password: e.target.value})
                }}
              />
              <button 
                onMouseDown={() => setShowPassword(true)}
                onMouseUp={() => setShowPassword(false)}
                onMouseLeave={() => setShowPassword(false)}
                onTouchStart={() => setShowPassword(true)}
                onTouchEnd={() => setShowPassword(false)}
                className="absolute right-5 top-[32px]">
                {showPassword ? 
                  <AiOutlineEye size={25} color="gray"/>
                  :
                  <AiOutlineEyeInvisible  size={25} color="gray"/>
                }
              </button>
            </Box>
             
            {errors.password && (
              <span className='text-[14px] text-red-500 font-bold relative top-[-8px]'>
                {errors.password}
              </span>
            )}
            {/* <FormControlLabel
              control={<Checkbox value='remember' color='primary' />}
              label='Remember me'
            /> */}
            <Button
              type='button'
              fullWidth
              variant='contained'
              sx={{ 
                mt: 3, 
                mb: 2,
                backgroundColor:'var(--color-primary-purple)',
                '&:hover': {
                backgroundColor: 'var(--color-primary-purple)',
                }, 
              }}
              onClick={loginAdmin}
            >
              Sign In
            </Button>
            {/* {errors.message && (
              <span className='text-[14px] text-center text-red-500 font-bold w-full block'>
                {errors.message}
              </span>
            )} */}
            {invalidLogin && (
            <span className='text-[14px] text-red-500 font-bold relative top-[8px]'>{invalidLogin}</span>
            )}
            {/* <Grid container>
              <Grid item xs>
                <Link href='#' variant='body2'>
                  Forgot password?
                </Link>
              </Grid>
            </Grid> */}
            </Box>
          </Box>
        </Container>
      </div>
		{inactiveMessage && (
			<span className='text-[18px] text-green-600 font-bold relative top-[8px]'>Logged out due to inactivity.</span>
        )}
    </div>
  );
}
